/* eslint-disable-file */
import $ from 'jquery';
import Portfolio from '../Portfolio/index';
import { createRoot } from 'react-dom/client';
import { getStudentImage } from '../../utils.js';
import React, { useState, useEffect, useRef } from 'react';

const ClassList = props => {
	if (!props.year) {
		return;
	}

	const [ page, setPage ] = useState(1);
	const [ students, setStudents ] = useState(new Array(8).fill({
		title: {
			rendered: ''
		},
		student_image: ''
	}));
	const [ loading, setLoading ] = useState(false);

	const ulElement = useRef();

	useEffect(() => {
		const load = async () => {
			setLoading(true);

			const students = await fetchStudents(props.year, page);

			if (!students.length) {
				return;
			}

			setStudents(current => page > 1 ? [ ...current, ...students ] : students);
			setLoading(false);
		};

		load();
	}, [ page ]);

	const loadMoreStudents = () => {
		const ul = ulElement.current;
		const scrolled = ul.scrollTop / (ul.scrollHeight - ul.offsetHeight);

		if (scrolled > 0.75 && !loading) {
			setPage(current => current + 1);
		}
	};

	return (
		<ul className="ClassCard-accordion-content-list" ref={ulElement} onScroll={loadMoreStudents}>
			{students.map((student, index) => (
				<li className="ClassCard-accordion-content-list-item" key={student.id || index}>
					<div className="ClassCard-accordion-content-list-item-image">
						{!student.id ?
							<img className="skeleton"/>
							: <img src={getStudentImage(student)}/>
						}
					</div>
					<div className="ClassCard-accordion-content-list-item-content">
						<span className={`${ !student.id ? 'skeleton skeleton-text' : '' }`}>
							{student.title.rendered.split(' ').slice(0, 2).filter(str => str).join(' ')}
						</span>
						<a className={`curriculo curriculo-${ student.id }`}>
							{!student.id ?
								<div className="skeleton skeleton-text"></div>
								: 'Ver currículo'
							}
						</a>
						{student.id &&
							<Portfolio bolsista={student} openModalButton={`a.curriculo-${ student.id }`} />
						}
					</div>
				</li>
			))}
		</ul>
	);
};

async function getTaxonomyId(year) {
	return new Promise((resolve, reject) => {
		$.ajax({
			method: 'GET',
			url: `/wp-json/wp/v2/tax-category?slug=turma-${ year }`,
			success: data => {
				resolve(data[0].id);
			},
			error: reject
		});
	});
}

async function fetchStudents(year, page = 1) {
	const taxonomyId = await getTaxonomyId(year);

	if (!taxonomyId) {
		return;
	}

	return new Promise((resolve, reject) => {
		$.ajax({
			method: 'GET',
			url: `/wp-json/wp/v2/scholarship?tax-category=${ taxonomyId }&per_page=20&page=${ page }&orderby=title&order=asc`,
			success: resolve,
			error: (err) => {
				if (err.status === 400) {
					return resolve([]);
				}

				reject(err);
			}
		});
	});
}

const cards = document.querySelectorAll('.ClassCard');

if (cards.length) {
	for (const card of cards) {
		const year = card.getAttribute('data-year');

		if (year) {
			const button = card.querySelector('.ClassCard-accordion-button');

			const renderClassList = () => {
				const root = createRoot(card.querySelector('.ClassCard-accordion-content-list-wrapper'));
				root.render(<ClassList year={year} />);
				button.removeEventListener('click', renderClassList);
			}

			if (button) {
				button.addEventListener('click', renderClassList);
			}
		}
	}
}
